module.exports = __webpack_public_path__ + "img/DB_Inactive.db699de2.png";